import{a as r}from"./chunk-IEE7G5JG.js";function l(...e){return r(p,e)}var p=(e,t)=>{let a=t;return(n,u,o)=>(a=e(a,n,u,o),{done:!1,hasNext:!0,next:a})};export{l as a};
